export default __webpack_public_path__ + "media/images/upgrade_block-84f13f08621066ca3f980f554d4fbaa0.jpg";